import { usePlanStore } from '@/store/planStore';
import { useDocumentStore } from '@/store/documentStore';
import { getPlanLimits } from '@/lib/planLimits';

export function usePlanGating() {
  const plan = usePlanStore((s) => s.plan);
  const limits = getPlanLimits(plan);
  const nodes = useDocumentStore((s) => s.nodes);

  return {
    canCreateMap: (mapCount: number) => limits.maxMaps === -1 || mapCount < limits.maxMaps,
    canAddNode: () => limits.maxNodesPerMap === -1 || nodes.size < limits.maxNodesPerMap,
    canExportPdf: limits.canExportPdf,
    canExportPng: limits.canExportPng,
    canCollaborate: limits.canCollaborate,
    canPublish: limits.canPublish,
    canUseAllLayouts: limits.canUseAllLayouts,
    canUseAllThemes: limits.canUseAllThemes,
    plan,
    limits,
    isFreePlan: plan === 'free',
    isPaidPlan: plan !== 'free',
  };
}
